// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"e67d0ac2ba56462328c79c2b7cf45551b11b666c"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;import * as Sentry from '@sentry/nextjs';

Sentry.init({
	dsn: 'https://1056b3278ea458672ba876af01e23f36@o4508807514816512.ingest.us.sentry.io/4508808861122560',
	maxValueLength: 2047,

	// Add optional integrations for additional features
	integrations: [
		Sentry.replayIntegration({
			maskAllText: false,
			blockAllMedia: true,
		}),
		Sentry.browserTracingIntegration(),
		Sentry.browserProfilingIntegration(),
	],

	sendDefaultPii: true,

	// Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
	tracesSampleRate: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? 0.1 : 1.0,

	// Define how likely Replay events are sampled.
	// This sets the sample rate to be 10%. You may want this to be 100% while
	// in development and sample at a lower rate in production
	replaysSessionSampleRate: 0.1,

	// Define how likely Replay events are sampled when an error occurs.
	replaysOnErrorSampleRate: 1.0,

	// Setting this option to true will print useful information to the console while you're setting up Sentry.
	debug: process.env.NEXT_PUBLIC_ENVIRONMENT === 'development',

	beforeSend(event, hint) {
		return new Promise((resolve) => {
			setTimeout(() => {
				event.tags = {
					...event.tags,
					domain: window.location.hostname,
					isBuilderPreview: window.location.search.includes('builder.preview='),
					isFeatheryForm: !!document.querySelector('[data-feathery-id]'),
				};

				// Ignore certain builder.io preview errors
				if (
					window.location.search.includes('builder.preview=') &&
					hint?.originalException instanceof Error &&
					hint.originalException.message?.includes('builder')
				) {
					resolve(null); // Ignore event
				} else {
					resolve(event); // Proceed with event
				}
			}, 100); // Small delay (100ms) to allow DOM updates
		});
	},
});
